import { FlagsSchema } from '../registries/flags.js';
import { z } from '../zod.js';
import { IsoTimestamp } from './common.js';
export const LoginRequest = z.strictObject({
    username: z.string().min(1).max(64),
    password: z.string().min(1).max(1024),
});
export const SessionScope = z.enum(['gm', 'smoke']);
/** `auth.me`: the signed-in user and every feature flag, resolved by the server. */
export const MeResponse = z.strictObject({
    username: z.string().min(1).max(64),
    scope: SessionScope,
    expiresAt: IsoTimestamp,
    flags: FlagsSchema,
});
/** The web app reads flags only from `auth.me`, through this accessor. */
export function flagsFromMe(me) {
    return Object.freeze({ ...FlagsSchema.parse(me.flags) });
}
//# sourceMappingURL=auth.js.map